!function() {
  class t extends HTMLElement {
    constructor() {
      super(), this._onScroll = this._onScroll.bind(this);
    }
    connectedCallback() {
      requestAnimationFrame(() => this._setup());
    }
    disconnectedCallback() {
      window.removeEventListener("scroll", this._onScroll), this._resizeObserver && this._resizeObserver.disconnect();
    }
    _setup() {
      this._labels = Array.from(this.querySelectorAll("[data-timeline-label]")), this._fills = Array.from(this.querySelectorAll("[data-timeline-line] .bg-scheme-links")), 
      this._blocks = Array.from(this.querySelectorAll("[data-timeline-block]")), this._contentBoxes = this._collectByIndex("data-timeline-content"), 
      this._dots = this._collectByIndex("data-timeline-dot"), this._activatedBlocks = new Set, 
      this._lastActiveIndex = -1, this._navEl = this.querySelector("[data-timeline-sticky-bar]"), 
      this._updateOffsets(), this._resizeObserver = new ResizeObserver(() => this._updateOffsets()), 
      this._resizeObserver.observe(document.documentElement), window.addEventListener("scroll", this._onScroll, {
        passive: !0
      }), this._onScroll();
    }
    _collectByIndex(t) {
      return this._blocks.map((e, s) => Array.from(this.querySelectorAll(`[${t}="${s}"]`)));
    }
    _updateOffsets() {
      const t = getComputedStyle(document.documentElement);
      this._headerHeight = parseFloat(t.getPropertyValue("--header-combined-height")) || 0, 
      this._stickyHeight = this.querySelector("[data-timeline-sticky-bar]")?.offsetHeight || 0;
    }
    _scrollNavToLabel(t) {
      if (!this._navEl || t === this._lastActiveIndex) return;
      const e = this._labels[t];
      if (!e) return;
      const s = this._navEl.scrollLeft, i = this._navEl.offsetWidth, l = e.offsetLeft;
      if (l + e.offsetWidth > s + i || l < s) {
        const t = l - i / 2 + e.offsetWidth / 2;
        this._navEl.scrollTo({
          left: t,
          behavior: "smooth"
        });
      }
    }
    _onScroll() {
      const t = window.scrollY + this._headerHeight + this._stickyHeight;
      let e = -1;
      if (this._blocks.forEach((s, i) => {
        const l = window.scrollY + s.getBoundingClientRect().top, o = Math.max(0, Math.min(1, (t - l) / (s.offsetHeight || 1)));
        this._fills[i] && (this._fills[i].style.width = 100 * o + "%"), l <= t && l + s.offsetHeight > t && (e = i);
      }), -1 === e) {
        e = 0;
        for (let s = this._blocks.length - 1; s >= 0; s--) if (window.scrollY + this._blocks[s].getBoundingClientRect().top <= t) {
          e = s;
          break;
        }
      }
      this._scrollNavToLabel(e), this._lastActiveIndex = e, this._labels.forEach((t, s) => {
        t.classList.toggle("text-scheme-muted", s > e), t.classList.toggle("text-scheme-text", s <= e), 
        s === e ? t.setAttribute("aria-current", "true") : t.removeAttribute("aria-current");
      }), this._blocks.forEach((t, e) => {
        const s = this._contentBoxes[e]?.[0];
        if (s) {
          const t = s.getBoundingClientRect(), i = Math.min(t.bottom, window.innerHeight) - Math.max(t.top, 0) >= .5 * t.height || t.top <= 0, l = this._activatedBlocks.has(e);
          i && !l ? (this._activatedBlocks.add(e), this._contentBoxes[e]?.forEach(t => {
            t.classList.replace("bg-scheme-contrast", "bg-scheme-icons");
          }), this._dots[e]?.forEach(t => {
            t.classList.replace("bg-scheme-text", "bg-scheme-icons");
          })) : !i && l && (this._activatedBlocks.delete(e), this._contentBoxes[e]?.forEach(t => {
            t.classList.replace("bg-scheme-icons", "bg-scheme-contrast");
          }), this._dots[e]?.forEach(t => {
            t.classList.replace("bg-scheme-icons", "bg-scheme-text");
          }));
        }
      });
    }
  }
  customElements.get("timeline-element") || customElements.define("timeline-element", t);
}();